// components/common/TextSection.tsx

import React from "react";
import { TextSectionData } from "../../types/interfaces";
import "../../styles/TextSection.css";

const TextSection: React.FC<TextSectionData> = ({ title, content,id }) => {
  return (
    <section className="text-section" id={id}>
      <h2>{title}</h2>
      <div
        className="text-content"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </section>
  );
};

export default TextSection;
